import { RadioGroup, FormControlLabel, Radio, Grid } from '@mui/material';
import { AsyncButton } from 'components/ButtonNew/Button';
import { Form } from 'components/Form/Form';
import { TextInput } from 'components/Form/TextInput';
import Joi from 'joi';
import { QueryParameters } from 'lib/types';
import * as React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

const schema = Joi.object({
  filter: Joi.object({
    q: Joi.string().allow(null, ''),
    status: Joi.string().allow(null, ''),
    source_store: Joi.string().allow(null, ''),
    completeness_of_stock: Joi.string().allow(null, '')
  })
});

const defaultValues = {
  filter: {
    q: '',
    status: 'all',
    source_store: 'all',
    completeness_of_stock: 'all'
  }
}

let formhooks: UseFormReturn = null
const FilterImportStock = ({
  setQuery,
  setPagination,
  isEdit = false
}: {
  setQuery: React.MutableRefObject<(e: QueryParameters) => QueryParameters>;
  setPagination: React.Dispatch<React.SetStateAction<any>>;
  isEdit?: boolean;
}): JSX.Element => {
  const submitRef = React.useRef(null)

  const onSubmit = (data, e) => {
    if (isEdit) e.preventDefault();
    const values = data.filter;
    // Handle form submission logic here

    setPagination((prev) => ({
      ...prev,
      page: 1
    }));
    setQuery.current({
      q: values.q || '',
      ...(values.status !== 'all'
        ? {
          failedImport: Boolean(values.status === 'failed')
        }
        : {}),
      ...(values.source_store !== 'all'
        ? {
          isMaster: Boolean(values.source_store === 'master')
        }
        : {}),
      ...(values.completeness_of_stock !== 'all'
        ? {
          hasStock: Boolean(values.completeness_of_stock === 'true')
        }
        : {})
    });
  };

  function getFormHooks(hooks: UseFormReturn) {
    formhooks = hooks;
    submitRef.current = hooks.handleSubmit(onSubmit, (err) => console.error(err))
  }

  const onReset = async () => {
    formhooks.setValue('filter', {
      q: '',
      status: 'all',
      source_store: 'all',
      completeness_of_stock: 'all'
    } as any);
    setPagination((prev) => ({
      ...prev,
      page: 1
    }));
    setQuery.current({});
  };

  return (
    <Form values={defaultValues} schema={schema} getFormHooks={getFormHooks} onSubmit={onSubmit} shouldUnregister={false}>
      <Grid container display="flex" flexDirection="column" rowSpacing={1}>
        <Grid item display="flex" alignItems="center" justifyContent="space-between">
          <p className="font-weight-bold mb-0">Filter</p>
          <AsyncButton size="small" color="error" variant="text" type="button" onClick={onReset}>
            Reset
          </AsyncButton>
        </Grid>
        <Grid item>
          <TextInput name="filter.q" variant="outlined" label="" placeholder="Cari produk SKU" />
        </Grid>
        <Grid item>
          <label className="font-weight-bold" htmlFor="import-filter-status">
            Status
          </label>
          <Controller
            name="filter.status"
            control={formhooks?.control}
            defaultValue="all"
            render={({ field }) => (
              <RadioGroup
                {...field}
                id="import-filter-status"
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              >
                <FormControlLabel value="all" control={<Radio />} label="Semua" />
                <FormControlLabel value="failed" control={<Radio />} label="Gagal Import dari Marketplace" />
              </RadioGroup>
            )}
          />
        </Grid>
        <Grid item>
          <label className="font-weight-bold" htmlFor="import-filter-source-store">
            Toko Asal
          </label>
          <Controller
            name="filter.source_store"
            control={formhooks?.control}
            defaultValue="all"
            render={({ field }) => (
              <RadioGroup
                {...field}
                id="import-filter-source-store"
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              >
                <FormControlLabel value="all" control={<Radio />} label="Semua" />
                <FormControlLabel value="master" control={<Radio />} label="Master" />
                <FormControlLabel value="non_master" control={<Radio />} label="Non Master" />
              </RadioGroup>
            )}
          />
        </Grid>
        <Grid item>
          <label className="font-weight-bold" htmlFor="import-filter-completeness-stock">
            Kelengkapan Stok
          </label>
          <Controller
            name="filter.completeness_of_stock"
            control={formhooks?.control}
            defaultValue="all"
            render={({ field }) => (
              <RadioGroup
                {...field}
                id="import-filter-completeness-stock"
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              >
                <FormControlLabel value="all" control={<Radio />} label="Semua" />
                <FormControlLabel value="true" control={<Radio />} label="Ada" />
                <FormControlLabel value="false" control={<Radio />} label="Tidak ada stok" />
              </RadioGroup>
            )}
          />
        </Grid>
        <Grid item>
          <AsyncButton
            type="submit"
            variant="contained"
            color="primary"
            className="w-100"
          >
            Terapkan
          </AsyncButton>
        </Grid>
      </Grid>
    </Form>
  );
};

export default FilterImportStock;
